import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ContentKey } from "../../../../features/talentProfile/TalentDetails";
import { ReactComponent as EditIcon } from "../../../icons/editGray.svg";

type Props = {
  id: string;
  handleOpenEditModal: (contentKey: ContentKey, id: string) => void;
  contentKey?: string;
};

const EditButton = ({ handleOpenEditModal, contentKey, id }: Props) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="text"
      startIcon={<EditIcon />}
      onClick={() =>
        handleOpenEditModal(`${contentKey}_edit` as ContentKey, id)
      }
    >
      <Typography color="textSecondary" fontSize="14px">
        {t("common:edit")}
      </Typography>
    </Button>
  );
};

export default EditButton;
